import React from 'react';
import { GalleryManager } from '../../components/Gallery/GalleryManager';
import { PageHeader } from '@/components/ui/PageHeader/PageHeader';
import { PageContainer } from '@/components/ui/PageContainer';

export function OrgGallery() {
  return (
    <PageContainer>
      <PageHeader
        title="Gallery"
        description="Manage your organization's shared images and media assets. Supported formats: JPG, PNG, SVG, WebP, and AVIF."
      />

      <div className="min-h-[500px]">
        <GalleryManager
          onClose={() => {}}
          embedded={true}
        />
      </div>
    </PageContainer>
  );
}
